/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_N4Inputs */

const en_sorter_ref_n4 = /** @type {(inputs: Sorter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a natural sort. Compared as text, so 1 precedes 2.`)
};

const ko_sorter_ref_n4 = /** @type {(inputs: Sorter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자연 정렬이 아닙니다. 텍스트로 비교되므로 1이 2보다 앞입니다.`)
};

const ja_sorter_ref_n4 = /** @type {(inputs: Sorter_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自然順ソートではありません。テキストとして比較されるので 1 が 2 より前です。`)
};

/**
* | output |
* | --- |
* | "Not a natural sort. Compared as text, so 1 precedes 2." |
*
* @param {Sorter_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_n4 = /** @type {((inputs?: Sorter_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_n4(inputs)
	if (locale === "ko") return ko_sorter_ref_n4(inputs)
	return ja_sorter_ref_n4(inputs)
});